module.exports = __webpack_public_path__ + "static/media/plan-ex2.eb56d8a7.png";